// Brand assets for Pit Stop Motors
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_auto-ministry/artifacts/htzfx6s9_file.png";

const PUBLIC_DOMAIN = "https://pitstopmotors.store";

export const BRAND = {
  name: "Pit Stop Motors",
  state: "Idaho",
  dealerNumber: "DLR # 0448",
  domain: "pitstopmotors.store",
  publicUrl: PUBLIC_DOMAIN,
  publicApi: `${PUBLIC_DOMAIN}/api`,
  phone: "208-789-8284",
  phoneHref: "tel:+12087898284",
  email: "Kendall@Pit-Stop-Motors.com",
  addressLine1: "3323 Port St. #203",
  addressLine2: "Nampa, Idaho 83687",
  mapsHref: "https://www.google.com/maps/search/?api=1&query=3323+Port+St+Nampa+Idaho+83687",
  facebookUrl: "https://www.facebook.com/profile.php?id=61579877392132",
  carsforsaleUrl: "https://www.carsforsale.com",
  googleReviewUrl: "https://maps.google.com/?cid=1454568215524228420",
};
